<template>
  <FormSect class="FormResearch">
    <TabsHead
      :indexActive.sync="tabIndex"
      :labels="tabsLabels">
      <template #tabSuffix="{ isActive, index }">
        <Tag v-if="counts[index]" class="info" :class="{ light: !isActive }">
          {{ counts[index] }}
        </Tag>
      </template>
    </TabsHead>
    <!--
    <FormQuestionsAnswers
      v-if="tabIndex === 0"
      :fact="questionsAnswersFact"
      @create="createFact(FACT_TYPES.QUESTIONS_ANSWERS)"
      @update:fact="updateFact" />
    -->
    <FormFactList
      v-if="factsTemplateVisible"
      :key="factsTemplateVisible.type"
      :fact="factsByType[factsTemplateVisible.type]"
      :factTemplate="factsTemplateVisible"
      :section="section"
      :sectionTemplate="sectionTemplate"
      @create="createFact(factsTemplateVisible.type, $event)"
      @update:fact="updateFact"
      @update:section="$up('section', section)" />
  </FormSect>
</template>

<script>
import { actions, getters } from '@utils'
import { append, indexBy, prop } from 'rambda'
import FormFactList from './FormFactList'
import TabsHead from '@components/TabsHead'
import { mergeById } from '@utils/collections'

export default {
  components: {
    FormFactList,
    TabsHead,
  },
  props: {
    article: Object,
    facts: Array,
    section: Object,
    sectionTemplate: Object,
  },
  data() {
    return {
      isCreating: false,
      tabIndex: 0,
    }
  },
  computed: {
    factsTemplates() {
      return this.sectionTemplate.factsTemplates || []
    },
    factsTemplateVisible() {
      return this.factsTemplates[this.tabIndex]
    },
    factsByType() {
      return indexBy(prop('type'), this.facts)
    },
    tabsLabels() {
      return this.factsTemplates
        .map(({ type }) => this.factTypesByKey[type].label)
    },
    counts() {
      return this.factsTemplates
        .map(({ type }) => this.factsByType[type]?.items?.length || 0)
    },
    ...getters(
      'factFactory',
      'factTypesByKey',
    ),
  },
  methods: {
    async createFact(type, doFill) {
      const fact = this.factFactory({
        articleId: null,
        sectionId: this.section.id,
        siteId: this.article.siteId,
        type,
        $doFill: doFill,
      })

      const factCreated = await this
        .$wrap(this.CREATE_FACT(fact), 'isCreating')

      this.$up('facts', append(factCreated, this.facts))
    },
    updateFact(fact) {
      this.$up('facts', mergeById(fact, this.facts))
    },
    ...actions(
      'CREATE_FACT',
    ),
  },
}
</script>

<style lang="scss">
$_info-lightish: mix($info, $info-light);

.FormSect.FormResearch {
  padding: 0;

  .Empty {
    .Btn {
      margin: 0 $grid-gutter-width;
    }
  }

  > .TabsHead {
    background: $info-lighter;
    color: $_info-lightish;
    margin-bottom: $grid-unit-half;

    .Tab {
      &.isActive {
        border-color: $info-light;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "fetch": "Fetch"
  }
}
</i18n>
